import { render, staticRenderFns } from "./BaseFlexItem.vue?vue&type=template&id=45162cc6"
import script from "./BaseFlexItem.vue?vue&type=script&lang=js"
export * from "./BaseFlexItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports